import React, { FunctionComponent } from "react";

const AppWindowIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/programing-apps-websites/apps-window/app-window
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <defs></defs>
      <title>app-window</title>
      <rect
        x="1.51"
        y="2.253"
        width="21"
        height="19.5"
        rx="1.5"
        ry="1.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></rect>
      <line
        x1="1.51"
        y1="6.753"
        x2="22.51"
        y2="6.753"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </svg>
  );
};

export default AppWindowIcon;
